import React, { useEffect, useMemo, useState, useContext } from 'react';
import { Context } from '../../../context/UserContext';

import { useNavigateParams } from '../../../hooks/useNavigateParams';
import { MaterialReactTable } from 'material-react-table';

import { ThemeProvider } from '@mui/material';
/* tema customizado*/
import tableThemeCustom from '../../form/tableThemeCustom';

/* hooks */
import useFlashMessage from '../../../hooks/useFlashMessage';

import * as TabelaAPI from '../../../api/tabela';

//Import Material React Table Translations
import { MRT_Localization_PT_BR } from 'material-react-table/locales/pt-BR';
import CustomDialog from '../../layout/CustomDialog';

import { Box, Button, IconButton, Tooltip } from '@mui/material';
import { Delete, Edit, PictureAsPdf } from '@mui/icons-material';
import PrintIcon from '@mui/icons-material/Print';

import CrudsAPI from '../../../api/CRUDs';

/* util */
import { obterPermissoesUsuario } from '../../../utils/funcoes';
import { prepareOptions } from '../../../hooks/usePermisionMRT';
import { relatorios } from '../../../api/relatorios';
import { obterInicioEFimDoMes } from '../../../utils/financeiro';
import { getEmpresaScope } from '../../../helpers/sessionEmpresa';
import { resolveEmpresaTabela } from '../../../utils/funcoes';
import { retornaDataBr } from '../../../utils/retornaDataFormatada';

import { useMRTState } from '../../../hooks/useMRTState';
import { podeEditar, podeImprimir, podeIncluir, podeCancelar } from '../../../hooks/usePermisionMRT';
const Index = () => {
    const [dados, setDados] = useState([]);
    const [enumParentesco, setEnumParentesco] = useState([]);
    const token = localStorage.getItem('token') || '';
    const { setFlashMessage } = useFlashMessage();
    const navigate = useNavigateParams();
    const urlParams = new URLSearchParams(window.location.search);

    const ul = urlParams.get('ul');
    const li = urlParams.get('li');
    const tipo = urlParams.get('tipo');
    const operacaoUUID = urlParams.get('operacao');
    const uuid = urlParams.get('uuid');
    const btnText = urlParams.get('btnText') || 'Cadastrar';

    const pathname = '/RH/CreateOrEdit';

    const { parametro } = useContext(Context);
    const { pessoaId, empresaId, empresaIds } = getEmpresaScope();
    const empresaTabelaId = resolveEmpresaTabela(parametro, empresaId);

    const params = new URLSearchParams({
        ul: ul,
        li: li,
        tipo: tipo,
        operacao: operacaoUUID,
        uuid: uuid,
        btnText: btnText,
    });

    //configuração por tipo de RH
    const RH_TIPOS = {
        funcional: {
            titulo: 'Ficha funcional dos colaboradores',
            api: CrudsAPI.rh,
            tabelaImpressao: 'rhMovimento',
        },

        ferias: {
            titulo: 'Férias dos colaboradores',
            api: CrudsAPI.rhFerias,
            tabelaImpressao: 'rhFerias',
        },

        afastamento: {
            titulo: 'Afastamentos dos colaboradores',
            api: CrudsAPI.rhAfastamentos,
            tabelaImpressao: 'rhAfastamento',
        },

        vacinacao: {
            titulo: 'Vacinação dos colaboradores',
            api: CrudsAPI.vacinacao,
            tabelaImpressao: 'rhVacinacao',
        },

        exame: {
            titulo: 'Exames dos colaboradores',
            api: CrudsAPI.rhExame,
            tabelaImpressao: 'rhExame',
        },

        declaracao: {
            titulo: 'Declarações vinculadas aos colaboradores',
            api: CrudsAPI.declaracoes,
            tabelaImpressao: 'rhDeclaracao',
        },
        declaracaoTipos: {
            titulo: 'Tipos de declarações utilizados no sistema',
            api: CrudsAPI.rhDeclaracaoTipos,
            tabelaImpressao: 'rhDeclaracaoTipo',
        },
        dependente: {
            titulo: 'Dependentes vinculados aos colaboradores',
            api: CrudsAPI.rhDependentes,
            tabelaImpressao: 'rhDependentes',
        },
    };
    //configuração dos enums por tipo
    const RH_ENUMS = {
        dependente: () => consultaEnum('rhDependentes', 'parentesco'),
        //vacinacao: () => consultaEnum("rhVacinacao", "dose"),
    };

    //obtem configuração por tipo
    const config = RH_TIPOS[tipo] ?? {
        titulo: 'Movimentações de RH',
        api: CrudsAPI.rh,
        tabelaImpressao: tabelaImpressao,
    };
    // desestrutura config
    const { titulo: gridTitulo, api, tabelaImpressao } = config;

    const mrt = useMRTState({
        storageKey: `rh:${tipo || 'default'}`,
        pageSizeDefault: parametro?.paginacao ?? 5,
    });

    useEffect(() => {
        setEnumParentesco([]);
        const load = async () => {
            RH_ENUMS[tipo]?.();
        };
        load();
    }, [tipo]);

    //dialog customizado
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    const fetchData = async () => {
        if (!dados.length) {
            mrt.setIsLoading(true);
        } else {
            mrt.setIsRefetching(true);
        }

        try {
            const { data } = await api.listarObj({
                start: mrt.pagination.pageIndex * mrt.pagination.pageSize,
                size: mrt.pagination.pageSize,
                filters: JSON.stringify(mrt.columnFilters ?? []),
                filtersMode: JSON.stringify(mrt.columnFilterFns ?? []),
                globalFilter: mrt.globalFilter ?? '',
                sorting: JSON.stringify(mrt.sorting ?? []),
                tipoConsulta: tipo,
            });
            setDados(data.data);
            mrt.setRowCount(data.meta.totalRowCount);
        } catch (error) {
            mrt.setIsError(true);
            console.error(error);
            return;
        }
        mrt.setIsError(false);
        mrt.setIsLoading(false);
        mrt.setIsRefetching(false);
    };

    const consultaEnum = async (table, field, filter) => {
        const result = await TabelaAPI.enums(table, field, filter);

        const mappedResult = prepareOptions(result);

        if (table === 'rhDependentes' && field === 'parentesco') {
            setEnumParentesco(mappedResult);
        }
    };

    //funções do dialog
    const handleOpenDialog = (row) => {
        setOpenDialog(true);
        setSelectedRow(row);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
    };

    const handleConfirmDialog = async () => {
        // Verifique se há uma linha selecionada
        let msgType = 'success';
        if (selectedRow) {
            // Lógica de confirmação
            try {
                const { data } = await api.deletar(selectedRow);
                setFlashMessage(data.message, msgType);

                fetchData();
            } catch (error) {
                msgType = 'error';
                console.error(error);
                setFlashMessage(error.response.data.message, msgType);
            }
        }
        setOpenDialog(false);
    };

    useEffect(() => {
        if (!token) {
            return navigate('/Auth', { replace: true });
        }

        //permissões do usuario
        obterPermissoesUsuario(pessoaId, empresaId, ul, li);

        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        token,
        mrt.columnFilterFns,
        mrt.columnFilters,
        mrt.globalFilter,
        mrt.pagination.pageIndex,
        mrt.pagination.pageSize,
        mrt.sorting,
        tipo,
    ]);

    const getColumnsByTipo = (tipo, gridTitulo) => {
        if (tipo === 'afastamento') {
            return [
                {
                    id: 'RH',
                    header: gridTitulo,
                    columns: [
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                        {
                            accessorKey: 'numero',
                            header: 'Número',
                        },
                        {
                            accessorKey: 'Pessoa.descricao',
                            header: 'Colaborador',
                        },
                        {
                            accessorKey: 'rhCID.descricao',
                            header: 'CID',
                        },
                        {
                            accessorKey: 'dataVigenciaInicio',
                            header: 'Início',
                            accessorFn: (row) => new Date(row.dataVigenciaInicio),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.dataVigenciaInicio)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'dataVigenciaFim',
                            header: 'Término',
                            accessorFn: (row) => new Date(row.dataVigenciaFim),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.dataVigenciaFim)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'acidente',
                            header: 'Acidente',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.acidente; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                    ],
                },
            ];
        } else if (tipo === 'declaracao') {
            return [
                {
                    id: 'RH',
                    header: gridTitulo,
                    columns: [
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                        {
                            accessorKey: 'numero',
                            header: 'Número',
                        },
                        {
                            accessorKey: 'Pessoa.descricao',
                            header: 'Colaborador',
                        },

                        {
                            accessorKey: 'rhDeclaracaoTipo.descricao',
                            header: 'Tipo de Declaração',
                        },
                        {
                            accessorKey: 'dataVigenciaInicio',
                            header: 'Início',
                            accessorFn: (row) => new Date(row.dataVigenciaInicio),
                            Cell: ({ row }) => (
                                <span>
                                    {row.original.dataVigenciaInicio ? retornaDataBr(row.original.dataVigenciaInicio) : ''}
                                </span>
                            ),
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'dataVigenciaFim',
                            header: 'Término',
                            accessorFn: (row) => new Date(row.dataVigenciaFim),
                            Cell: ({ row }) => (
                                <span>{row.original.dataVigenciaFim ? retornaDataBr(row.original.dataVigenciaFim) : ''}</span>
                            ),
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'vigente',
                            header: 'Vigente',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.vigente; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'ativo',
                            header: 'Ativo',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.ativo; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                    ],
                },
            ];
        } else if (tipo === 'declaracaoTipos') {
            return [
                {
                    id: 'RH',
                    header: gridTitulo,
                    columns: [
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                        {
                            accessorKey: 'dataVigenciaInicio',
                            header: 'Validade',
                            accessorFn: (row) => new Date(row.dataVigenciaInicio),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.dataVigenciaInicio)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'dataVigenciaFim',
                            header: 'Validade',
                            accessorFn: (row) => new Date(row.dataVigenciaFim),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.dataVigenciaFim)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'exameAdmissao',
                            header: 'Exame Admissional',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.exameAdmissao; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'exameDemissao',
                            header: 'Exame Demissional',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.exameDemissao; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'examePeriodico',
                            header: 'Exame Períodico',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.examePeriodico; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'ativo',
                            header: 'Ativo',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.ativo; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                    ],
                },
            ];
        } else if (tipo === 'funcional') {
            return [
                {
                    id: 'RH',
                    header: gridTitulo,
                    columns: [
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                        {
                            accessorKey: 'numero',
                            header: 'Número',
                        },
                        {
                            accessorKey: 'Pessoa.descricao',
                            header: 'Colaborador',
                        },
                        {
                            accessorKey: 'Setor.descricao',
                            header: 'Setor',
                        },
                        {
                            accessorKey: 'rhCargo.descricao',
                            header: 'Cargo',
                        },
                        {
                            accessorKey: 'rhNivel.descricao',
                            header: 'Nível',
                        },
                        {
                            accessorKey: 'admissao',
                            header: 'Data Admissão',
                            accessorFn: (row) => new Date(row.admissao),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.admissao)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'vigente',
                            header: 'Vigente',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.vigente;
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'ativo',
                            header: 'Ativo',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.ativo;
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                    ],
                },
            ];
        } else if (tipo === 'dependente') {
            return [
                {
                    id: 'RH',
                    header: gridTitulo,
                    columns: [
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                        {
                            accessorKey: 'Pessoa.descricao',
                            header: 'Colaborador',
                        },
                        {
                            accessorKey: 'Dependente.descricao',
                            header: 'Dependente',
                        },
                        {
                            accessorKey: 'parentesco',
                            header: 'Parentesco',
                            filterFn: 'equals',
                            columnFilterModeOptions: ['fuzzy', 'equals', 'notEquals'],
                            filterVariant: 'select',
                            filterSelectOptions: enumParentesco
                                .sort((a, b) => a.label.localeCompare(b.label))
                                .map((option) => ({
                                    label: option.label,
                                    value: option.label,
                                })),
                        },
                        {
                            accessorKey: 'dataInicio',
                            header: 'Início',
                            accessorFn: (row) => new Date(row.dataInicio),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.dataInicio)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'dataFim',
                            header: 'Fim',
                            accessorFn: (row) => new Date(row.dataFim),
                            Cell: ({ row }) => <span>{row.dataFim ? retornaDataBr(row.original.dataFim) : ''}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'dependenteIR',
                            header: 'Imposto de Renda',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.dependenteIR; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'dependentePlanoSaude',
                            header: 'Plano de Saúde',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.dependentePlanoSaude; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'dependenteSalarioFamilia',
                            header: 'Salário Família',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.dependenteSalarioFamilia; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'ativo',
                            header: 'Ativo',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.ativo; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                    ],
                },
            ];
        } else if (tipo === 'ferias') {
            return [
                {
                    id: 'RH',
                    header: gridTitulo,
                    columns: [
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                        {
                            accessorKey: 'numero',
                            header: 'Número',
                        },
                        {
                            accessorKey: 'Pessoa.descricao',
                            header: 'Colaborador',
                        },
                        {
                            accessorKey: 'exercicio',
                            header: 'Exercício',
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                                onClick: () => {
                                    // Ação ao clicar na célula
                                },
                            }),
                        },
                        {
                            accessorKey: 'dataVigenciaInicio',
                            header: 'Início',
                            accessorFn: (row) => new Date(row.dataVigenciaInicio),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.dataVigenciaInicio)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'dataVigenciaFim',
                            header: 'Término',
                            accessorFn: (row) => new Date(row.dataVigenciaFim),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.dataVigenciaFim)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'provisao',
                            header: 'Provisão',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.provisao;
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'Pessoa.pessoaColaborador.ativo',
                            header: 'Colaborador Ativo',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original?.Pessoa?.pessoaColaborador?.ativo;
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                    ],
                },
            ];
        } else if (tipo === 'vacinacao') {
            return [
                {
                    id: 'RH',
                    header: gridTitulo,
                    columns: [
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                        {
                            accessorKey: 'numero',
                            header: 'Número',
                        },
                        {
                            accessorKey: 'Pessoa.descricao',
                            header: 'Colaborador',
                        },
                        {
                            accessorKey: 'rhVacina.descricao',
                            header: 'Vacina',
                        },
                        {
                            accessorKey: 'dose',
                            header: 'Dose',
                        },
                        {
                            accessorKey: 'dataVigenciaInicio',
                            header: 'Aplicação',
                            accessorFn: (row) => new Date(row.dataVigenciaInicio),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.dataVigenciaInicio)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'dataVigenciaFim',
                            header: 'Validade',
                            accessorFn: (row) => new Date(row.dataVigenciaFim),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.dataVigenciaFim)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'ativo',
                            header: 'Ativo',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.ativo; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                    ],
                },
            ];
        } else if (tipo === 'exame') {
            return [
                {
                    id: 'RH',
                    header: gridTitulo,
                    columns: [
                        {
                            accessorKey: 'Empresa.nomeFantasia',
                            header: 'Empresa',
                        },
                        {
                            accessorKey: 'numero',
                            header: 'Número',
                        },
                        {
                            accessorKey: 'Pessoa.descricao',
                            header: 'Colaborador',
                        },
                        {
                            accessorKey: 'rhTabela27eSocial.codigo',
                            header: 'Código',
                        },
                        {
                            accessorKey: 'rhTabela27eSocial.descricao',
                            header: 'Exame',
                        },
                        {
                            accessorKey: 'dataVigenciaInicio',
                            header: 'Data',
                            accessorFn: (row) => new Date(row.dataVigenciaInicio),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.dataVigenciaInicio)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'dataVigenciaFim',
                            header: 'Validade',
                            accessorFn: (row) => new Date(row.dataVigenciaFim),
                            Cell: ({ row }) => <span>{retornaDataBr(row.original.dataVigenciaFim)}</span>,
                            filterVariant: 'date',
                            sortingFn: 'date',
                            columnFilterModeOptions: [
                                'fuzzy',
                                'equals',
                                'between',
                                'betweenInclusive',
                                'greaterThanOrEqualTo',
                                'lessThanOrEqualTo',
                            ],
                            muiTableBodyCellProps: { align: 'center' },
                            muiTableHeadCellFilterTextFieldProps: {
                                type: 'date',
                                InputLabelProps: {
                                    shrink: true,
                                },
                                sx: { minWidth: '180px' },
                            },
                        },
                        {
                            accessorKey: 'exameAdmissao',
                            header: 'Exame Admissional',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.exameAdmissao; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'exameDemissao',
                            header: 'Exame Demissional',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.exameDemissao; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'examePeriodico',
                            header: 'Exame Períodico',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.examePeriodico; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                        {
                            accessorKey: 'ativo',
                            header: 'Ativo',
                            filterVariant: 'select', // Define o filtro como seletor
                            filterFn: 'equals', // Define o tipo de filtro como "igual"
                            filterSelectOptions: [
                                { label: 'Todos', value: '' },
                                { label: 'Sim', value: '1' },
                                { label: 'Não', value: '0' },
                            ],
                            muiTableBodyCellProps: ({ row, cell }) => ({
                                align: 'center', // Alinha a célula ao centro
                            }),
                            Cell: ({ row, cell }) => {
                                // Renderiza o checkbox na célula
                                const value = cell.getValue() === '1' || row.original.ativo; // Verifica se o valor é "1" para ativado
                                return <div style={{ textAlign: 'center' }}>{value ? 'Sim' : 'Não'}</div>;
                            },
                        },
                    ],
                },
            ];
        }
    };
    const columns = useMemo(() => {
        if (!tipo) return [];
        return getColumnsByTipo(tipo, gridTitulo);
    }, [tipo, enumParentesco, gridTitulo]);

    /* modo tema */
    const theme = tableThemeCustom();

    return (
        <div>
            <div>
                {openDialog && (
                    <CustomDialog
                        title={`Delete ${gridTitulo}!`}
                        content="Você tem certeza?"
                        onClose={handleCloseDialog}
                        onConfirm={handleConfirmDialog}
                    />
                )}
            </div>
            <ThemeProvider theme={theme}>
                <MaterialReactTable
                    displayColumnDefOptions={{
                        'mrt-row-actions': {
                            muiTableHeadCellProps: {
                                align: 'center',
                            },
                            size: 100,
                        },
                        'mrt-row-numbers': {
                            enableColumnOrdering: true, //turn on some features that are usually off
                            enableResizing: true,
                            muiTableHeadCellProps: {
                                sx: {
                                    fontSize: '1.2rem',
                                },
                            },
                        },
                        'mrt-row-select': {
                            enableColumnActions: true,
                            enableHiding: true,
                            size: 50,
                        },
                    }}
                    enableColumnFilterModes
                    enableGlobalFilterModes
                    //enableColumnResizing
                    enableColumnOrdering
                    enableEditing
                    renderRowActions={({ row, table }) => {
                        const handleDeclaracao = async (obj) => {
                            const { rhDeclaracaoTipo } = obj;

                            const caminho = rhDeclaracaoTipo.caminho;
                            const url = rhDeclaracaoTipo.url;
                            const response = await relatorios(caminho, url, obj);

                            // Cria um Blob a partir dos dados do arraybuffer
                            const pdfBlob = new Blob([response.data], {
                                type: 'application/pdf',
                            });

                            // Cria um URL temporário para o Blob
                            const pdfUrl = URL.createObjectURL(pdfBlob);

                            // Use o URL do PDF para abrir em uma nova janela ou realizar outras ações
                            window.open(pdfUrl);
                        };
                        const handleComprovantes = async (row) => {
                            params.set('uuid', row.id);
                            params.set('empresaId', row.original.empresaId);
                            navigate('CreateOrEditComprovante', params);
                        };
                        return (
                            <Box sx={{ display: 'flex', gap: '1rem' }}>
                                <Tooltip arrow placement="left" title="Editar">
                                    <span>
                                        {' '}
                                        <IconButton
                                            onClick={() => {
                                                params.set('uuid', row.id);
                                                params.set('btnText', 'Atualizar');
                                                navigate(pathname, params);
                                            }}
                                            disabled={!podeEditar()}
                                        >
                                            <Edit />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                <Tooltip arrow placement="right" title="Deletar">
                                    <span>
                                        <IconButton
                                            color="error"
                                            onClick={() => handleOpenDialog(row)}
                                            disabled={!podeCancelar()}
                                        >
                                            <Delete />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                                {tipo.toLocaleLowerCase() === 'declaracao' && (
                                    <Tooltip arrow placement="top-start" title={`${'Emitir Declaração'}`}>
                                        <span>
                                            <IconButton
                                                //color="info"
                                                onClick={() => {
                                                    handleDeclaracao(row.original);
                                                }}
                                                disabled={!podeImprimir()}
                                            >
                                                <PrintIcon />
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                )}

                                <Tooltip arrow placement="top-start" title={`${'Anexar comprovante, recibo, declaração, etc'}`}>
                                    <span>
                                        <IconButton
                                            color="error"
                                            onClick={() => {
                                                handleComprovantes(row);
                                            }}
                                            disabled={!podeEditar()}
                                        >
                                            <PictureAsPdf />
                                        </IconButton>
                                    </span>
                                </Tooltip>
                            </Box>
                        );
                    }}
                    renderTopToolbarCustomActions={({ table }) => {
                        const handleImprimir = async (obj) => {
                            const urlSearchParams = new URLSearchParams({
                                start: `${mrt.pagination.pageIndex * mrt.pagination.pageSize}`,
                                size: `${mrt.pagination.pageSize}`,
                                filters: JSON.stringify(mrt.columnFilters ?? []),
                                filtersMode: JSON.stringify(mrt.columnFilterFns ?? []),
                                globalFilter: mrt.globalFilter ?? '',
                                sorting: JSON.stringify(mrt.sorting ?? []),
                                tipo: tipo,
                                tabelas: tabelaImpressao,
                                empresaId: empresaIds,
                            });

                            const response = await api.imprimir(urlSearchParams, obj);

                            // Cria um Blob a partir do objeto do arraybuffer
                            const pdfBlob = new Blob([response.data], {
                                type: 'application/pdf',
                            });

                            // Cria um URL temporário para o Blob
                            const pdfUrl = URL.createObjectURL(pdfBlob);

                            // Use o URL do PDF para abrir em uma nova janela ou realizar outras ações
                            window.open(pdfUrl);
                        };
                        return (
                            <div
                                style={{
                                    display: 'flex',
                                    gap: '8px',
                                }}
                            >
                                <Tooltip arrow placement="top-end" title={`Novo Registro`}>
                                    <div>
                                        {' '}
                                        <Button
                                            color="secondary"
                                            onClick={() => {
                                                params.delete('uuid');
                                                params.set('btnText', 'Cadastrar');
                                                navigate(pathname, params);
                                            }}
                                            variant="contained"
                                            disabled={!podeIncluir()}
                                        >
                                            Novo
                                        </Button>
                                    </div>
                                </Tooltip>
                                <Tooltip arrow placement="top-end" title={`Imprimir ${gridTitulo}`}>
                                    <div>
                                        <span>
                                            <Button
                                                color="info"
                                                variant="contained"
                                                disabled={!podeImprimir()}
                                                onClick={() => handleImprimir({})}
                                            >
                                                Imprimir
                                            </Button>
                                        </span>
                                    </div>
                                </Tooltip>
                            </div>
                        );
                    }}
                    columns={columns}
                    data={dados}
                    enableRowSelection
                    getRowId={(row) => row.uuid}
                    manualFiltering
                    manualPagination
                    manualSorting
                    muiToolbarAlertBannerProps={
                        mrt.isError
                            ? {
                                  color: 'error',
                                  children: 'Error loading data',
                              }
                            : undefined
                    }
                    onColumnFiltersChange={mrt.setColumnFilters}
                    onColumnFilterFnsChange={mrt.setColumnFiltersMode}
                    onGlobalFilterChange={mrt.setGlobalFilter}
                    onPaginationChange={mrt.setPagination}
                    onSortingChange={mrt.setSorting}
                    rowCount={mrt.rowCount}
                    initialState={{
                        showColumnFilters: true,
                        density: 'compact',
                        //columnPinning: { left: ["mrt-row-select"] },
                    }}
                    state={{
                        columnFilterFns: mrt.columnFilterFns,
                        columnFilters: mrt.columnFilters,
                        globalFilter: mrt.globalFilter,
                        isLoading: mrt.isLoading,
                        pagination: mrt.pagination,
                        showAlertBanner: mrt.isError,
                        showProgressBars: mrt.isRefetching,
                        sorting: mrt.sorting,
                    }}
                    //positionToolbarDropZone={"top"}
                    positionExpandColumn={'first'}
                    positionActionsColumn={'first'}
                    positionToolbarAlertBanner="bottom"
                    localization={MRT_Localization_PT_BR}
                />
            </ThemeProvider>
        </div>
    );
};
export default Index;
